/**
 * LeadCTRL brand + theme tokens — THE single source of truth.
 *
 * Change the product name, wordmark or accent here and the whole app re-themes.
 * Accent maps to Tailwind's `teal` palette (teal-700 === #0F766E), so components
 * use `teal-*` utility classes; JS-only consumers (e.g. Leaflet pins) read the hex
 * values below.
 */
export const brand = {
  name: "LeadCTRL",
  family: "CaterCTRL Family",
  wordmarkMark: "L", // single-letter mark used in the logo lockup
  tagline: "Field-sales CRM for hospitality",
  phase: "Phase 1a",
  version: "1.0.0-phase1a",
};

export const accent = {
  // Deep teal — WCAG AA on white for text at these weights.
  base: "#0F766E", // teal-700
  hover: "#115E59", // teal-800
  soft: "#CCFBF1", // teal-100
  softBorder: "#99F6E4", // teal-200
  foreground: "#FFFFFF",
  // Tailwind class fragments so components stay consistent.
  bg: "bg-teal-700",
  bgHover: "hover:bg-teal-800",
  text: "text-teal-700",
  ring: "focus:ring-teal-600",
};

export const neutrals = {
  background: "#F8FAFC",
  surface: "#FFFFFF",
  muted: "#F1F5F9",
  border: "#E2E8F0",
  textPrimary: "#0F172A",
  textSecondary: "#475569",
  textMuted: "#64748B",
};

// Status → badge styling (Tailwind classes).
export const statusStyles = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  customer: "bg-teal-50 text-teal-700 border-teal-200",
  prospect: "bg-blue-50 text-blue-700 border-blue-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
  lost: "bg-rose-50 text-rose-700 border-rose-200",
  do_not_contact: "bg-red-50 text-red-700 border-red-200",
};

export const radii = { sm: "0.375rem", md: "0.5rem", lg: "0.75rem", xl: "1rem" };

export default { brand, accent, neutrals, statusStyles, radii };
